export default [
    {
        path: 'topic/:id/report',
        name: 'view-topic-report',
        component: () => import('pages/topic_modeling/index.vue'),
    },
    {
        path: 'topic/:id/analyze',
        name: 'analyze-topic',
        component: () => import('pages/topic_modeling/create/index.vue'),
    },
];
